<template>
	<header>
		<slot>
			<hero-image :item="headingImage" />
		</slot>
	</header>
</template>

<script setup>
defineProps({
	headingImage: {
		type: Object,
		default: () => {},
	},
});
</script>
